import isEmpty from "validator/lib/isEmpty";

const isCompanyCode = /^[A-Za-z0-9]+$/;

let isValid = true;
export const validateCreateCompany = (input, colorPrimary, colorSecondary) => {
  let isValid = true;

  if (input.company_code === undefined || isEmpty(input.company_code) || !isCompanyCode.test(input.company_code)) {
    isValid = false;
  }

  if (input.company_name === undefined || isEmpty(input.company_name)) {
    isValid = false;
  }
  if (input.company_address === undefined || isEmpty(input.company_address)) {
    isValid = false;
  }

  if (input.company_bill_type === undefined || isEmpty(input.company_bill_type)) {
    isValid = false;
  }

  if (input.customer_bill_type === undefined || isEmpty(input.customer_bill_type)) {
    isValid = false;
  }

  if (colorPrimary === undefined) {
    isValid = false;
  }

  if (colorSecondary === undefined) {
    isValid = false;
  }

  return { isValid: isValid };
};

export const validateCreateCustomer = (input, isValidateCustomerSaleId) => {
  if (input.customer_code === undefined || isEmpty(input.customer_code) || !isCompanyCode.test(input.customer_code)) {
    isValid = false;
  }

  if (input.customer_name === undefined || isEmpty(input.customer_name)) {
    isValid = false;
  }

  if (input.customer_company === undefined) {
    isValid = false;
  }

  if (isValidateCustomerSaleId) {
    if (input.customer_sale === undefined) {
      isValid = false;
    }
  } else {
    isValid = false;
  }

  return { isValid: isValid };
};
